import { ROLES, type UserRole } from '@shared/config/constants'

export const ROLE_HOME_ROUTES: Record<UserRole, string> = {
  [ROLES.ADMIN]: '/admin',
  [ROLES.PARTICIPANT]: '/participant/dashboard',
  [ROLES.REPRESENTATIVE]: '/representative',
}
